<template>
  <div class="test-record">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>答题记录</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search">
      <div>
        <el-input
          placeholder="请输入内容"
          prefix-icon="el-icon-search"
          size="small"
          v-model="key"
        ></el-input>
      </div>
      <div> <el-button type="primary" size="small" @click.native="Query">查询</el-button></div>
    </div>
    <div class="time-screen">
      <div class="time">
        <el-date-picker
          v-model="time_slot"
          size="small"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <el-button type="primary" size="small"  @click.native="Query_1">确认</el-button>

    </div>
    <div class="list">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        size="small"
      >
        <el-table-column
          prop="questionnaire_name"
          label="问卷名称">
        </el-table-column>
        <el-table-column
          prop="user_name"
          label="用户名">
        </el-table-column>
        <el-table-column
          prop="c_time"
          label="问卷时间">
        </el-table-column>
        <el-table-column
          prop="score"
          label="得分">
        </el-table-column>
        <el-table-column
          prop="id"
          label="操作">
          <template slot-scope="scope">
            <el-button type="info"  size="small" @click="goTo('/test-info',scope.row.id)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

  </div>
</template>


<script>
  export default {
    data() {
      return {
        pages:1,
        limit: 10,
        key: '',
        tableData: [],
        total:0,
        time_slot: ['',''],
        start_time: '',
        end_time: '',
        article_name:''
      }
    },
    methods: {
      getList(){
        this.$get('/v1/admin/questionnaire/answer-record?&pages=' + this.pages + '&limit=' + this.limit+ '&key=' + this.key  + '&start_time=' + this.start_time + '&end_time=' + this.end_time, {})
          .then((res) => {
            console.log(res)
            if (res.data.status === 'success') {
              this.tableData = res.data.data.data;
              this.total = res.data.data.total;
            } else {
              this.$msg(res.data.msg)
            }
          });
      },
      Query(){
        this.pages = 1;
        this.getList();
      },
      Query_1(){
        this.pages = 1;
        this.start_time= this.time_slot[0];
        this.end_time= this.time_slot[1];
        this.getUserList();
      },
      tableRowClassName({row, rowIndex}) {
        if (rowIndex %2 === 1) {
          return '';
        } else {
          return 'success-row';
        }
      },
      handleSizeChange(val) {
        this.limit = val;
        this.getList()
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.pages = val;
        this.getList()
        console.log(`当前页: ${val}`);
      },
      goTo(path,id){
        this.$router.push({
          path:path,
          query:{
            id:id
          }
        })
      }
    },
    created() {
      this.getList()
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .test-record
    .el-table .warning-row {
      background: oldlace;
    }

    .el-table .success-row {
      background: #f0f9eb;
    }

    .search
      margin 20px 0
      display flex
      justify-content flex-start
      input
        width 200px
        margin-right 20px

    .time-screen
      margin-bottom:20px;
      display flex
      align-items center
      >span
        margin-right: 10px;
      .time
        margin: 0 10px 0 0;

    .list
      min-height 550px
      border 1px solid #EBEEF5
      .edit_icon
        width 20px
        height 20px
        margin-left 16px
        border 1px solid  #ccc
        border-radius 4px

    .block
      margin-top: 10px;

</style>



// WEBPACK FOOTER //
// src/pages/TestRecord/TestRecord.vue